(() => {
  if (window.shoptimizerContactConversion) return;
  window.shoptimizerContactConversion = true;
  const key = 'shoptimizer.contact.pending.v1';
  const bound = new WeakSet();

  function allowed() {
    return window.shoptimizerConsent?.allowed(['analytics', 'marketing', 'sale_of_data']) === true;
  }

  function complete(form) {
    let attempts = 0;
    function publish() {
      try {
        const pending = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (!pending || pending.form !== form.id || pending.path !== location.pathname) return;
        const age = Date.now() - pending.at;
        const ready = typeof window.Shopify?.customerPrivacy?.currentVisitorConsent === 'function';
        if (!Number.isFinite(age) || age < 0 || age > 1800000 || (ready && !allowed())) {
          sessionStorage.removeItem(key);
          return;
        }
        // Customer Privacy and the analytics publisher load asynchronously after navigation.
        if (!ready || !window.shoptimizerCustomerEvents || typeof window.Shopify?.analytics?.publish !== 'function') {
          if (++attempts < 40) setTimeout(publish, 250);
          else sessionStorage.removeItem(key);
          return;
        }
        sessionStorage.removeItem(key);
        if (allowed()) window.shoptimizerCustomerEvents.publish(
          'shoptimizer_contact_submitted', {form_id: form.id}, pending.id
        );
      } catch (_) {}
    }
    publish();
  }

  function connect() {
    for (const marker of document.querySelectorAll('[data-contact-conversion]')) {
      const form = marker.closest('form');
      if (!form?.id || bound.has(form)) continue;
      bound.add(form);
      form.addEventListener('submit', () => {
        try {
          sessionStorage.removeItem(key);
          if (!allowed() || !form.checkValidity()) return;
          sessionStorage.setItem(key, JSON.stringify({
            id: crypto.randomUUID(), form: form.id, path: location.pathname, at: Date.now()
          }));
        } catch (_) {}
      });
      if (marker.dataset.contactSuccess !== 'true') continue;
      complete(form);
    }
  }

  document.addEventListener('DOMContentLoaded', connect);
  window.addEventListener('pageshow', connect);
  document.addEventListener('visitorConsentCollected', () => {
    try { if (!allowed()) sessionStorage.removeItem(key); } catch (_) {}
  });
  connect();
})();
